import React, { useEffect, useState, useMemo, useRef } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { useParams } from "react-router-dom";
import moment from "moment";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

export default function SettlementPopup() {
  const { userId } = useParams();

  const [settledAmount, setSettledAmount] = useState(0);
  const [amountSettled, setAmountSettled] = useState(0);
  const [description, setDescription] = useState("P/L to Cash transfer");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  var userObj = {};
  userObj.user_id = userId;
  const fetchBetDetails = async () => {
    const response = await axiosInstance.post("/company/settle-popup", userObj);
    setSettledAmount(Math.abs(response.data.settled_amount));
    setIsLoading(false);
  };

  useEffect(() => {
    fetchBetDetails();
  }, []);

  const [isLoading, setIsLoading] = useState(true);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const handleSettledAmount = (e) => {
    var amount = e.target.value;
    setAmountSettled(amount);
  };

  const handleDescription = (e) => {
    var description = e.target.value;
    setDescription(description);
  };

  const handleSubmit = async () => {
    try {
      setErrorMessage("");
      setSuccessMessage("");
      var obj = {};
      obj.TransferAmount = amountSettled;
      obj.Description = description;
      obj.user_id_settle = userId;

      const response = await axiosInstance.post(
        "/company/save-settlement",
        obj
      );
      if (
        response !== null &&
        response !== undefined &&
        response.data !== null &&
        response.data !== undefined
      ) {
        setSuccessMessage(response.data.M);
        setAmountSettled(0);
        setDescription("P/L to Cash transfer");
        fetchBetDetails();
      }
    } catch (error) {
      let errorData = error.response.data;

      if (errorData !== null && errorData !== undefined && !errorData.status) {
        setErrorMessage(errorData.message);
      }
    }
  };

  return (
    <>
      <div className="animated fadeIn" style={{ margin: 0 }}>
        <div className="container-fluid p-0">
          {/* small style overrides are added below using a standard <style> element */}
          <div className="row w-100 m-0">
            <div className="col-12 p-0">
              <div className="card">
                <div
                  className="card-body"
                  style={{ padding: "5px 5px 0px 5px" }}
                >
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="card">
                        <div class="card-header">Settle P/L Account</div>
                        <div class="card-body">
                          <p class="text-danger">
                            <strong id="msgSuccess"></strong>
                          </p>

                          <div
                            class="alert alert-success"
                            style={{
                              display: successMessage != "" ? "" : "none"
                            }}
                          >
                            <strong className="site_family">
                              {successMessage}
                            </strong>
                          </div>

                          <div
                            class="alert alert-danger"
                            style={{
                              display: errorMessage != "" ? "" : "none"
                            }}
                          >
                            <strong className="site_family">
                              {errorMessage}
                            </strong>
                          </div>

                          <div class="form-group">
                            <label for="exampleInputEmail1">Amount</label>
                            <input
                              class="form-control"
                              id="numAmount"
                              type="text"
                              name="TransferAmount"
                              value={amountSettled}
                              onChange={handleSettledAmount}
                            />
                            <small
                              id="emailHelp"
                              class="form-text text-muted"
                              style={{ fontSize: "15px" }}
                            >
                              Max amount to transfer:
                              <span
                                style={{ color: "black", fontSize: "17px" }}
                              >
                                {formatTruncate(settledAmount)}
                              </span>
                            </small>
                            <br />
                            <label for="exampleInputEmail1">Description</label>
                            <input
                              class="form-control"
                              id="DesText"
                              type="text"
                              name="Description"
                              value={description}
                              onChange={handleDescription}
                            />
                            <div class="form-group editsbmtbtn mt-2">
                              <button
                                class="btn btn-primary"
                                type="button"
                                id="btnpopup_settle"
                                name="btnpopup_settle"
                                onClick={handleSubmit}
                              >
                                <strong>Submit</strong>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SAFE CSS (no dangerouslySetInnerHTML) */}
      <style>{`
        .table { width: 100% !important; }
        .table.table-striped td, .table.table-striped th {
          padding: 6px 8px !important;
          font-size: 16px;
          white-space: normal !important;
          vertical-align: middle;
        }
        .toggle-row {
          border: none;
          cursor: pointer;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          font-weight: 700;
          font-size: 14px;
          color: #fff;
          background:#28a745;
          display:flex;
          align-items:center;
          justify-content:center;
        }
        .toggle-open { background:#dc3545 !important; }
        .summary-table th { text-align:left; border: 0; padding: 0.25rem 0; }
        @media (max-width: 640px) {
          .summary-table th { display:block; width:100%; white-space:normal; font-size:14px; }
          .table.table-striped td, .table.table-striped th { font-size:14px !important; padding:6px 6px !important; }
        }
      `}</style>
    </>
  );
}
